import React, { useState, useEffect } from 'react';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import { API_BASE } from '../config';
import { useLanguage } from '../context/LanguageContext';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const { t } = useLanguage();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/portfolio`);
        const data = await res.json();
        setProjects(data.projects || []);
      } catch (error) {
        console.error('Error fetching projects:', error);
        setProjects([
          {
            id: 6,
            title: 'Smart Agrotrack',
            description: 'Automated Greenhouse Monitoring & Control System. An IoT-based solution for monitoring and controlling greenhouse conditions.',
            image_url: '/images/projects/Automated_Greebhouse.png',
            technologies: ['C#', 'Arduino IDE', 'IoT Sensors'],
            category: 'software',
            live_link: 'https://www.linkedin.com/feed/update/urn:li:activity:7448353870843473920/',
          },
          {
            id: 5,
            title: 'Inventory Management and stock taking app',
            description: 'A platform developed for africa university Fleet and Facilities Unit (FFU) for managing inventory and stock taking.',
            image_url: '/images/projects/FFUI.png',
            technologies: ['React', 'Node.js', 'Express', 'PostgreSQL'],
            category: 'web',
          },
          {
            id: 2,
            title: 'AU Transcript Clone',
            description: 'A clone of Africa University transcript system built with vanilla HTML and CSS.',
            image_url: '/images/projects/TableOrange.png',
            technologies: ['HTML', 'CSS'],
            category: 'web',
            github_link: 'https://github.com/BenBand/School-Results-Table',
            live_link: 'https://schooltimetemplate.netlify.app/'
          },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const filteredProjects = filter === 'all'
    ? projects
    : projects.filter(p => p.category === filter);

  return (
    <div className="projects-page">
      <section className="section" style={{ paddingTop: '8rem', background: 'var(--bg-light)' }}>
        <h2 className="section-title">{t('projects.title')}</h2>
        <p style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto 2rem', color: 'var(--text-light)', fontSize: '1.1rem' }}>
          {t('projects.subtitle')}
        </p>

        <div className="filter-buttons" style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '3rem' }}>
          <button
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
            style={{
              padding: '0.6rem 1.5rem',
              border: '2px solid var(--primary)',
              background: filter === 'all' ? 'var(--primary)' : 'transparent',
              color: filter === 'all' ? 'white' : 'var(--primary)',
              borderRadius: '50px',
              cursor: 'pointer',
              fontWeight: '600',
              transition: 'var(--transition)'
            }}
          >
            {t('projects.all')}
          </button>
          <button
            className={`filter-btn ${filter === 'web' ? 'active' : ''}`}
            onClick={() => setFilter('web')}
            style={{
              padding: '0.6rem 1.5rem',
              border: '2px solid var(--primary)',
              background: filter === 'web' ? 'var(--primary)' : 'transparent',
              color: filter === 'web' ? 'white' : 'var(--primary)',
              borderRadius: '50px',
              cursor: 'pointer',
              fontWeight: '600',
              transition: 'var(--transition)'
            }}
          >
            {t('projects.web')}
          </button>
          <button
            className={`filter-btn ${filter === 'software' ? 'active' : ''}`}
            onClick={() => setFilter('software')}
            style={{
              padding: '0.6rem 1.5rem',
              border: '2px solid var(--primary)',
              background: filter === 'software' ? 'var(--primary)' : 'transparent',
              color: filter === 'software' ? 'white' : 'var(--primary)',
              borderRadius: '50px',
              cursor: 'pointer',
              fontWeight: '600',
              transition: 'var(--transition)'
            }}
          >
            {t('projects.software')}
          </button>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}>Loading...</div>
        ) : (
          <div className="projects-grid" data-tour="projects-grid" style={{ maxWidth: '1100px', margin: '0 auto', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))' }}>
            {filteredProjects.map((project, index) => (
              <div key={project.id} className={`project-card fade-in-up stagger-${index % 3 + 1}`}>
                <div className="project-image">
                  <img src={project.image_url || '/ProjectsImages/FFUI.png'} alt={project.title} />
                  <div className="project-overlay"></div>
                </div>
                <div className="project-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="tech-tags">
                    {project.technologies?.map((tech, i) => (
                      <span key={i} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                  <div className="project-links">
                    {project.github_link && (
                      <a href={project.github_link} target="_blank" rel="noopener noreferrer" className="project-link">
                        <FaGithub /> {t('projects.code')}
                      </a>
                    )}
                    {project.live_link && (
                      <a href={project.live_link} target="_blank" rel="noopener noreferrer" className="project-link">
                        <FaExternalLinkAlt /> {t('projects.liveDemo')}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Projects;
